<template>
   <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="true"
    >
      
      <template #layoutContent>
        <Loader :is-loading="loading">
         <Card >
          <template #cardHeader>
            <div class="card-header  p-10">
              <div class="flex-grow-1">
                <div class="d-flex justify-content-between align-items-start flex-wrap ">
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-2">
                      <a href="#" class="text-gray-900 text-hover-primary fs-2 fw-bolder me-1">{{employe?.firstname}} {{employe?.lastname}}</a>
                      <a href="#">
                        <span class="svg-icon svg-icon-1 svg-icon-primary">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                            <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A3FF"></path>
                            <path class="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white"></path>
                          </svg>
                        </span>
                      </a>
                    </div>
                    <div class="d-flex flex-wrap fw-bold fs-6 pe-2">
                      <a href="#" class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                        <span class="svg-icon svg-icon-4 me-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"></path>
                            <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"></path>
                          </svg>
                        </span>
                        {{employe?.phone_code}}{{employe?.phone}}
                      </a>
                      <a href="#" class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
                      <span class="svg-icon svg-icon-4 me-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"></path>
                            <path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"></path>
                          </svg>
                        </span>
                        {{employe?.email}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          
            <div class="card-body p-0 m-0">
              <div class="card-header card-header-stretch min-h">   
                  <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x nav-stretch fs-6 border-0">
                    <li class="nav-item" @click="clickOnTab('kt_employe_others')" v-show="$can(abilities.VIEW_USER_PROFILE) && $canAccess(moduleAbilities.RH_CONTRACT)">
                      <a class="nav-link fs-3 fw-bold text-active-primary" :class="{ 'active' : route.query.tab === 'kt_employe_others' }" data-bs-toggle="tab" href="#kt_employe_others">{{ $t('user.others') }}</a>
                    </li>
                    <li class="nav-item" @click="clickOnTab('kt_employe_contracts')"  v-show="$can(abilities.VIEW_EMPLOYEE_CONTRACT)  && $canAccess(moduleAbilities.RH_CONTRACT)">
                      <a class="nav-link fs-3 fw-bold text-active-primary" :class="{ 'active' : route.query.tab === 'kt_employe_contracts' }" data-bs-toggle="tab" href="#kt_employe_contracts">{{ $t('user.contracts') }}</a>
                    </li>
                  </ul>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show"  :class="{ 'active' : route.query.tab === 'kt_employe_others' }" id="kt_employe_others" role="tabpanel" v-show="$can(abilities.VIEW_EMPLOYEE_CONTRACT)">
                  <div class="card  pt-4 mb-6 mb-xl-9">
                    <EmployeInfoForm :form="formData" is-edit/>
                  </div>
                </div>

                <div class="tab-pane fade show" :class="{ 'active' : route.query.tab === 'kt_employe_contracts' }"  id="kt_employe_contracts" role="tabpanel" v-show="$can(abilities.VIEW_EMPLOYEE_CONTRACT)">
                  <div class="card  pt-4 mb-6 mb-xl-9">
                    <ContractList/>
                  </div>
                </div>
              </div>
            </div>
         </Card>
        </Loader>
      </template>
    </SubLayout>
  
</template>

<script setup>
import { onMounted, ref} from "vue";
import { useRouter, useRoute } from 'vue-router'
import {useStore} from "vuex";
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Loader from "@/components/Loader.vue";
import EmployeInfoForm from "./components/EmployeInfoForm.vue";
import Card from "@/components/Card.vue";
import { formatDate } from "@/mixins/Helpers";
import ContractList from "../Contracts/components/ContractList.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()

const title = ref("breadcrumbs.folder.title")
const breadcrumbs  = ref([
  {
    name : 'breadcrumbs.folder.detail',
    path : ''
  },
])

const employe = ref({
})

const loading = ref(false)

const formData = ref({
})


onMounted(() => {
  clickOnTab("kt_employe_others")
  loadEmploye()
})

function clickOnTab(tabId){
  router.replace({ query: { ...route.query, tab: tabId } });
}

async function loadEmploye(){
  loading.value = true
  store.dispatch('employes/getEmployeFolder',route.params.id).then((res) => {
    let data = res.data.employee
    employe.value = data
    formData.value = {
      user_id: data.id,
      lastname: data.lastname,
      firstname: data.firstname,
      phone_code:data.phone_code,
      phone:data.phone,
      department_id:data.department_id,
      post_id:data.post_id,
      birthday:formatDate(data.birthday),
      address:data.address,
      date_in_service:formatDate(data.date_in_service),
      social_security_number:data.social_security_number,
      employee_family_status_id:data.employee_family_status_id,
      employee_post_category_id:data.employee_post_category_id,
      nationality_id:data.nationality_id,
      nbrHolidays:data.nbrHolidays, 
    }
  }).finally(() => loading.value = false)

}


</script>

<style scoped>
.min-h{
  height: 50px!important;
}


</style>
